import { popularBreedsResourceDefinition } from 'dpl/reviews/utils/queryDefinitions';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

const LEARN_MORE_POPULAR_BREEDS = [
  'golden-retriever',
  'poodle',
  'dachshund',
  'australian-shepherd'
];

export default function usePopularBreeds() {
  const {
    value: { data: popularBreedsData },
    isFetching
  } = useResourceQuery(
    popularBreedsResourceDefinition({
      homepage: true
    })
  );

  const learnMorePopularBreeds = LEARN_MORE_POPULAR_BREEDS.map(slug =>
    popularBreedsData.find(breed => breed.slug === slug)
  ).filter(breed => breed !== undefined);

  return {
    popularBreedsData,
    isFetching,
    learnMorePopularBreeds
  };
}
